<template>
    <div class="w-full flex flex-column relative xl:max-w-30rem lg:max-w-30rem md:max-w-30rem gap-2">
        <div class="w-full flex flex-row align-items-center gap-2 mb-2">
            <i class="pi pi-paperclip text-500"></i>
            <span class="flex text-sm font-medium xl:text-lg text-900">
                {{ titleLabel }}
            </span>
        </div>
        
        <Message v-if="showMessage && (!files || files.length==0)" severity="warn" class="border-round-xl mb-2" icon="pi pi-paperclip">
            <span class="line-height-2 text-sm xl:text-md lg:text-sm">{{ hintLabel }}</span>
        </Message>

        <div class="w-full flex flex-column xl:max-w-30rem lg:max-w-30rem md:max-w-30rem relative">
            <UploadFiles :multiple="false" :maxFiles="1" :data="{transfer_id: id, from: from}"
                @onUpload="upload" @onReset="resetFiles" @onLoading="setLoading" />
            <span class="text-xs text-600 mt-2">{{ content[lang_].formats }}</span>
        </div>

        <Message v-if="files && files.length>0" severity="success" class="border-round-xl">
            <span class="line-height-2 text-md xl:text-md lg:text-sm">{{ successLabel }}</span>
        </Message>
    </div>
</template>

<script>
import UploadFiles from '@/components/widgets/UploadFiles.vue'

export default {
    props: {
        id: {
            type: String,
            required: true
        },
        from: {
            type: String,
            default: 'sender',
        },
        showMessage: {
            type: Boolean,
            default: true
        },
        titleText: {
            type: String,
            default: null
        },
        successText: {
            type: String,
            default: null
        },
        hintText: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            files: [],
            loading: false,
            content: {
                ru: {
                    title: 'Прикрепите чек об оплате',
                    tg_bill: 'Прикрепите и отправьте чек по кнопке ниже, пожалуйста',
                    thank_you: 'Спасибо. Вы отправили чек',
                    formats: 'Поддерживаемые форматы: jpg, jpeg, png, gif, pdf'
                },
                en: {
                    title: 'Attach the payment receipt',
                    tg_bill: 'Please attach and send the receipt below',
                    thank_you: 'Thank you. You attached the receipt',
                    formats: 'Supported formats: jpg, jpeg, png, gif, pdf'
                },
            },
        }
    },
    components: {
        UploadFiles,
    },
    computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
        isTgApp: function () { return this.$store.getters.StateTgApp },
        titleLabel() {
            return this.titleText || this.content[this.lang_].title
        },
        hintLabel() {
            return this.hintText || this.content[this.lang_].tg_bill
        },
        successLabel() {
            return this.successText || this.content[this.lang_].thank_you
        },
	},
	methods: {
        setLoading(val){
            this.loading = val
        },
        resetFiles() {
            this.files = []
        },
        upload(files) {
            if(!files) return
            if(files.length > 0)
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if(file._id) this.files.push(file._id)
            }
            this.$emit('uploaded', { from: this.from, items: files })
        },
    }
}
</script>